export const popupCenter = (url, w, h) => {
	let left = (screen.width - w) / 2
	let top = (screen.height - h) / 4

	const newWindow = window.open(
		url,
		'_blank',
		`scrollbars=yes,
      resizable=no,
      width=${w},
      height=${h},
      top=${top},
      left=${left}`
	)

	// @ts-ignore
	if (window.focus && newWindow) newWindow.focus()

	return newWindow
}

export const openNewTab = url => {
	const newWindow = window.open(url, '_blank')

	// @ts-ignore
	if (window.focus && newWindow) newWindow.focus()

	return newWindow
}
